import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedSSRParkourBasedPricings: { scheduleIds: [], name: null, startDate: null, endDate: null, parkourBasedPricingFragments: [] },
  }),

  mutations: {
    setSelectedSSRParkourBasedPricings(state, ssrParkourBasedPricings) {
      Vue.set(state, "selectedSSRParkourBasedPricings", ssrParkourBasedPricings);
    },
  },

  actions: {
    //TODO: load, update, create
    createSSRParkourBasedPricings: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadSSRParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadSSRParkourBasedPricing: (context, id) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity/" + id).then((response) => {
        // return objectUtils.convertPublishModelToUpdateModel(response.data);
        return response.data;
      });
    },

    loadSSRServiceParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity/published").then((response) => {
        return response.data;
      });
    },

    updateSSRParkourBasedPricings: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity", request, {}).then((response) => {
        return response.data;
      });
    },
    deleteSSRParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/entity/" + additionalServiceParkourBasedPricings.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          additionalServiceParkourBasedPricings.intents = intents;
          additionalServiceParkourBasedPricings.intentId = response.data.id;
          return additionalServiceParkourBasedPricings;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishSSRParkourBasedPricings: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    loadSelectedSSRParkourBasedPricingsHistory: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/history/" + additionalServiceParkourBasedPricings.id, {})
        .then((response) => {
          return response.data;
        });
    },

    rejectSSRParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/reject/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          if (additionalServiceParkourBasedPricings.intents[0].type === "DELETE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents = null;
            additionalServiceParkourBasedPricings.intentId = 0;
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "DRAFT";
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "DRAFT";
          }
          return response.data;
        });
    },

    recallSSRParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/recall/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          //TODO:Name should starting with letter.
          helper.recallOrRejectEntity(additionalServiceParkourBasedPricings, "PARKOUR_BASED_PRICING");
          return response.data;
        });
    },

    cancelSSRParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/cancel/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          //TODO:Name should starting with letter.
          return response.data;
        });
    },

    sendToApprovalSSRParkourBasedPricings: (context, additionalServiceParkourBasedPricings) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/ssr-parkour-based-pricings/sendToApproval/" + additionalServiceParkourBasedPricings.intentId)
        .then((response) => {
          if (additionalServiceParkourBasedPricings.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
          } else if (additionalServiceParkourBasedPricings.intents[0].type === "'CREATE_ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING") {
            additionalServiceParkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },
  },
  getters: {
    getSelectedSSRParkourBasedPricings: (state) => {
      return state.selectedSSRParkourBasedPricings;
    },
  },
};
